import React from 'react';
import { BrowserRouter as Router, Routes, Route /*,Navigate*/ } from 'react-router-dom';
//import LandingPage from './pages/LandingPage';
import RecommendationMap from './components/RecommendationMap';
import { AppProvider } from './context/AppContext';
import { AuthProvider /*, useAuth*/ } from "./context/AuthContext";
//import Verify from './pages/Verify';
//import Register from './pages/Register';
//import Login from './pages/Login';

//function PrivateRoute({ children }) {
//  const { user } = useAuth();
//  return user ? children : <Navigate to="/login" replace />;
//}

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
          <Routes>
            <Route path="/" element={<RecommendationMap />} />
          </Routes>
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}


export default App;
